import React from "react";

interface TrailIconProps {
  fill?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const TrailIcon: React.FC<TrailIconProps> = ({
  fill = "currentColor",
  className,
  width = 24,
  height = 24,
}) => {
  return (
  <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 139.000000 139.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g
        transform="translate(0.000000,139.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M512 1360 c-192 -52 -350 -181 -433 -355 -54 -113 -72 -191 -72 -315
0 -123 19 -204 69 -304 93 -185 250 -311 449 -362 91 -22 247 -23 335 0 71 18
192 72 228 102 20 16 21 22 10 37 -12 16 -19 14 -103 -28 -49 -25 -117 -52
-150 -60 -76 -19 -222 -19 -305 1 -201 47 -379 208 -446 404 -35 101 -44 266
-20 360 104 406 529 604 906 422 105 -51 232 -177 283 -282 50 -103 68 -178
68 -290 0 -114 -18 -188 -70 -292 -38 -74 -38 -77 -21 -93 18 -16 20 -15 46
27 78 123 116 300 96 444 -25 167 -84 285 -202 404 -85 85 -155 130 -262 167
-101 37 -297 43 -406 13z"
        />
        <path
          d="M540 1274 c-209 -55 -372 -221 -426 -434 -23 -90 -15 -261 16 -349
29 -81 108 -199 168 -251 134 -115 325 -167 500 -136 83 15 186 56 230 92 22
18 23 21 8 49 -9 17 -16 38 -16 47 0 15 -4 15 -47 -4 -65 -29 -160 -22 -231
17 -28 15 -58 36 -67 45 -14 15 -19 15 -76 -4 -56 -18 -65 -18 -102 -5 -59 20
-90 69 -84 131 3 37 18 68 72 150 110 166 139 190 240 194 186 7 198 10 242
53 69 69 138 52 150 -38 3 -22 1 -53 -5 -70 -9 -27 -7 -38 14 -80 34 -64 42
-151 19 -211 -9 -25 -18 -52 -21 -60 -4 -14 44 -50 67 -50 14 0 68 114 86 183
22 83 21 225 -1 302 -62 213 -230 376 -441 430 -74 19 -222 18 -295 -1z m51
-131 c39 -23 79 -105 79 -160 0 -107 -78 -157 -150 -96 -40 34 -52 64 -51 137
0 65 18 101 62 123 30 16 26 16 60 -4z m291 -4 c29 -15 48 -70 48 -135 0 -92
-48 -149 -120 -142 -91 9 -107 173 -25 255 34 34 62 41 97 22z m-464 -245 c63
-44 85 -172 37 -219 -31 -32 -66 -32 -106 2 -87 73 -77 233 15 233 17 0 42 -7
54 -16z m-233 -114 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8
-4 11 -10z m-10 -29 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6 21 15 7z
m-5 -41 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m0 -24 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2
10 -4z m-5 -35 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6 21 15 7z m15 -40
c0 -17 42 -24 51 -10 8 11 12 10 24 -5 8 -11 15 -26 15 -33 0 -8 7 -25 16 -38
9 -14 12 -25 6 -25 -6 0 -14 9 -17 20 -3 11 -13 20 -20 20 -8 0 -12 6 -9 14 3
8 0 17 -7 22 -7 4 -10 3 -5 -4 12 -19 -17 -26 -31 -7 -7 11 -13 15 -13 10 0
-10 -29 27 -30 38 0 4 5 7 10 7 6 0 10 -4 10 -9z m164 -146 c3 -8 1 -15 -4
-15 -6 0 -10 7 -10 15 0 8 2 15 4 15 2 0 6 -7 10 -15z m-4 -35 c0 -3 -13 -14
-30 -23 -16 -10 -30 -25 -30 -33 0 -15 -16 -19 -24 -6 -6 9 29 42 44 42 6 0
10 6 10 13 0 8 7 14 15 14 8 0 15 -3 15 -7z m-80 -89 c0 -6 -4 -13 -10 -16 -5
-3 -10 1 -10 9 0 9 5 16 10 16 6 0 10 -4 10 -9z"
        />
        <path
          d="M789 786 c-165 -59 -220 -280 -101 -403 56 -57 104 -77 187 -78 53 0
81 5 115 22 41 21 45 21 62 6 13 -12 17 -25 13 -43 -7 -30 26 -78 131 -187 68
-72 103 -81 142 -40 44 46 32 72 -82 184 -84 82 -110 102 -137 105 -43 4 -47
24 -18 86 64 132 -3 299 -138 348 -48 17 -127 17 -174 0z m199 -73 c67 -54 77
-76 77 -163 0 -73 -2 -81 -31 -117 -47 -58 -88 -78 -161 -78 -52 0 -68 4 -105
30 -131 93 -114 284 32 350 55 24 143 14 188 -22z"
        />
        <path
          d="M816 666 c15 -12 19 -27 19 -78 0 -51 5 -69 23 -93 12 -16 20 -35 18
-42 -3 -7 -1 -13 4 -13 18 0 10 34 -14 63 -19 24 -22 37 -18 78 5 50 -15 99
-40 99 -7 0 -3 -6 8 -14z"
        />
        <path d="M889 638 c4 -28 6 -29 9 -9 2 13 0 27 -5 32 -6 6 -7 -3 -4 -23z" />
        <path
          d="M768 650 c6 -8 12 -37 12 -64 0 -50 38 -153 47 -130 2 7 -5 27 -16
45 -14 23 -21 51 -21 85 0 37 -5 55 -17 65 -15 11 -16 11 -5 -1z"
        />
        <path
          d="M891 564 c0 -16 6 -39 14 -50 8 -10 15 -14 15 -8 0 5 -4 14 -9 20 -5
5 -11 23 -14 39 l-4 30 -2 -31z"
        />
        <path d="M930 478 c0 -9 5 -20 10 -23 13 -8 13 5 0 25 -8 13 -10 13 -10 -2z" />
      </g>
    </svg>
  );
};

export default TrailIcon;
